import { render, staticRenderFns } from "./MainTextSection.vue?vue&type=template&id=74eaa1a2&scoped=true&"
import script from "./MainTextSection.vue?vue&type=script&lang=ts&"
export * from "./MainTextSection.vue?vue&type=script&lang=ts&"
import style0 from "./MainTextSection.vue?vue&type=style&index=0&id=74eaa1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eaa1a2",
  null
  
)

export default component.exports